// extracted by mini-css-extract-plugin
module.exports = {"usersCount":"styles_usersCount__2HYqr","dark":"styles_dark__O8ziF","limitUsers":"styles_limitUsers__32-iH"};